import styled from 'styled-components';
import CSS from 'csstype';

type DataRangePopupProps = {
  position?: CSS.Property.Position;
};

export const DataRangeWrapper = styled.div`
  position: relative;
  && .dottedDays {
    position: relative;
  }
  && .dottedDays::after {
    content: '•';
    font-size: 20px;
    color: red;
    position: absolute;
    top: 10px;
    left: 10px;
  }
  && .dottedDays-30 {
    position: relative;
  }
  && .dottedDays-30::after {
    content: '•';
    font-size: 20px;
    color: red;
    position: absolute;
    top: 10px;
    left: 10px;
    opacity: 0.3;
  }
  && .dottedDays-60 {
    position: relative;
  }
  && .dottedDays-60::after {
    content: '•';
    font-size: 20px;
    color: red;
    position: absolute;
    top: 10px;
    left: 10px;
    opacity: 0.6;
  }
`;

export const DateInput = styled.div`
  width: 100%;
  height: 50px;

  align-items: center;
  background-color: hsl(0, 0%, 100%);
  border-color: hsl(0, 0%, 80%);
  border-radius: 35px;
  border-style: solid;
  border-width: 1px;
  box-shadow: 0px 0px 3px #c4c4c4;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
  transition: all 100ms;
  box-sizing: border-box;
  border: 0;
  text-align: center;
  padding: 0 20px;
  color: hsl(0, 0%, 50%);
  cursor: default;

  &:hover {
    box-shadow: 0px 0px 15px #c4c4c4;
  }

  &.disabled {
    pointer-events: none;
    background-color: hsl(0, 0%, 95%);
  }
`;

export const ClearDate = styled.div`
  border-left: solid 1px hsl(0, 0%, 80%);
  color: hsl(0, 0%, 50%);
  font-size: 20px;
  font-weight: 300;
  padding: 10px;
  margin-left: 5px;
  cursor: pointer;
`;

export const DataRangePopup = styled.div<DataRangePopupProps>`
  position: ${({ position }) => (position ? position : 'static')};
  right: 0;
  z-index: 1;
`;
